import { useMutation } from "@tanstack/react-query";

import { useAuthActions } from "src/store/AuthStore";

type RoleScope = {
  roles: string[];
  flowFolderIds?: string[];
};

/**
 * Mints a session token carrying only the given roles, optionally narrowed to
 * a single flow folder. Passing an empty array drops the impersonation. The
 * reload is part of the mutation because every cached query in the
 * application was fetched under the previous token.
 */
export const useSetRoleScopeMutation = () => {
  const { setRoleScope } = useAuthActions();

  return useMutation({
    mutationKey: ["setRoleScope"],
    mutationFn: ({ roles, flowFolderIds }: RoleScope) =>
      setRoleScope(roles, flowFolderIds),
    onSuccess: () => {
      window.location.reload();
    },
  });
};
